<ng-container [ngSwitch]="uiFramework">
  <div *ngSwitchCase="'ionic'">
    <ion-grid
      class="w-full bg-accent-100 text-center p-0"
      fixed>
      <ion-row class="ion-align-items-center">
        <ng-container *ngFor="let day of days; index as i">
          <ion-col
            class="p-0"
            size="12">
            <ion-item
              class="radius-4 body-2"
              lines="full">
              <ion-label
                class="w-full data-type-select"
                slot="start">
                {{ day }}
              </ion-label>
              <ion-checkbox
                slot="end"
                [checked]="selectedDays[i]"
                (ionChange)="onDayChange(i)">
              </ion-checkbox>
            </ion-item>
          </ion-col>
        </ng-container>
      </ion-row>
    </ion-grid>
  </div>
  <div *ngSwitchCase="'material'">
    <div class="bg-white radius-4 p-3 pb-0">
      <div class="fx-row fx-gap-3">
        <ng-container *ngFor="let day of days; index as i">
          <mat-checkbox
            [checked]="selectedDays[i]"
            (change)="onDayChange(i)">
            {{ day }}
          </mat-checkbox>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
